/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userRewards.internal

import features.userRewards.models.UserRewardsModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class UserRewardsRequest : NetworkRequest() {

    suspend fun getUserRewards(
        overrideHeaders: Map<String, String>? = null,

    ): IOResult<UserRewardsModel> {
        return safeNetworkCall {
            get(
                endpoint = UserRewardsEndpoint,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
